import React from "react";
import { TableRow, TableCell } from "@mui/material";
import Typography from "@mui/material/Typography";

const TableRowNoData = ({ message, submessage, colSpan }) => (

    <TableRow style={{ background: "#fafafa" }}>
      <TableCell colSpan={20} align="center" style={{ padding: "24px" }}>
        <Typography
          variant="body1"
          style={{
            fontSize: '16px',
            color: 'gray',
            textAlign: 'left',
            fontWeight: "bold"
          }}
        >
          {message}
        </Typography>
        <Typography
          variant="body1"
          style={{
            fontSize: '16px',
            color: 'gray',
            textAlign: 'left',
          }}
        >
          {submessage}
        </Typography>
      </TableCell>
    </TableRow>
  

  );


  export default TableRowNoData